import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './vehicle-position-last.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const VehiclePositionLastDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const vehiclePositionLastEntity = useAppSelector(state => state.vehiclePositionLast.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="vehiclePositionLastDetailsHeading">
          <Translate contentKey="fleetSenseApp.vehiclePositionLast.detail.title">VehiclePositionLast</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{vehiclePositionLastEntity.id}</dd>
          <dt>
            <span id="created">
              <Translate contentKey="fleetSenseApp.vehiclePositionLast.created">Created</Translate>
            </span>
          </dt>
          <dd>{vehiclePositionLastEntity.created ? <TextFormat value={vehiclePositionLastEntity.created} type="date" format={APP_DATE_FORMAT} /> : null}</dd>
          <dt>
            <span id="latitude">
              <Translate contentKey="fleetSenseApp.vehiclePositionLast.latitude">Latitude</Translate>
            </span>
          </dt>
          <dd>{vehiclePositionLastEntity.latitude}</dd>
          <dt>
            <span id="longitude">
              <Translate contentKey="fleetSenseApp.vehiclePositionLast.longitude">Longitude</Translate>
            </span>
          </dt>
          <dd>{vehiclePositionLastEntity.longitude}</dd>
          <dt>
            <span id="odometer">
              <Translate contentKey="fleetSenseApp.vehiclePositionLast.odometer">Odometer</Translate>
            </span>
          </dt>
          <dd>{vehiclePositionLastEntity.odometer}</dd>
          <dt>
            <span id="speed">
              <Translate contentKey="fleetSenseApp.vehiclePositionLast.speed">Speed</Translate>
            </span>
          </dt>
          <dd>{vehiclePositionLastEntity.speed}</dd>
          <dt>
            <span id="vBat">
              <Translate contentKey="fleetSenseApp.vehiclePositionLast.vBat">V Bat</Translate>
            </span>
          </dt>
          <dd>{vehiclePositionLastEntity.vBat}</dd>
          <dt>
            <span id="vSupply">
              <Translate contentKey="fleetSenseApp.vehiclePositionLast.vSupply">V Supply</Translate>
            </span>
          </dt>
          <dd>{vehiclePositionLastEntity.vSupply}</dd>
          <dt>
            <span id="supplyOn">
              <Translate contentKey="fleetSenseApp.vehiclePositionLast.supplyOn">Supply On</Translate>
            </span>
          </dt>
          <dd>{vehiclePositionLastEntity.supplyOn}</dd>
          <dt>
            <span id="activated">
              <Translate contentKey="fleetSenseApp.vehiclePositionLast.activated">Activated</Translate>
            </span>
          </dt>
          <dd>{vehiclePositionLastEntity.activated ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.vehiclePositionLast.truckImplement">Truck Implement</Translate>
          </dt>
          <dd>{vehiclePositionLastEntity.truckImplement ? vehiclePositionLastEntity.truckImplement.licensePlate : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.vehiclePositionLast.company">Company</Translate>
          </dt>
          <dd>{vehiclePositionLastEntity.company ? vehiclePositionLastEntity.company.name : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.vehiclePositionLast.user">User</Translate>
          </dt>
          <dd>{vehiclePositionLastEntity.user ? vehiclePositionLastEntity.user.login : ''}</dd>
        </dl>
        <Button tag={Link} to="/vehicle-position-last" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/vehicle-position-last/${vehiclePositionLastEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default VehiclePositionLastDetail;
